import { DoneActorEvent } from 'xstate';
import {
  AuthenticatedEmittedEvent,
  AuthMachineContext,
  AuthMachineEvents,
  AuthenticateSuccessEvent,
  RefreshTokenSuccessEvent,
} from '../types';

export function notifyAuthenticated({
  event,
}: {
  context: AuthMachineContext;
  event: AuthMachineEvents;
}): AuthenticatedEmittedEvent {
  if (!event.type.includes('xstate.done.actor'))
    return { type: 'EMIT_AUTHENTICATED', accessToken: '' };

  const e = event as DoneActorEvent<
    AuthenticateSuccessEvent | RefreshTokenSuccessEvent
  >;
  if (
    e.output.type !== 'AUTHENTICATE_SUCCESS' &&
    e.output.type !== 'REFRESH_TOKEN_SUCCESS'
  )
    return { type: 'EMIT_AUTHENTICATED', accessToken: '' };

  // A token refresh establishes no new identity, so only a login success
  // carries the email — see AuthenticatedEmittedEvent.
  if (e.output.type === 'REFRESH_TOKEN_SUCCESS') {
    return {
      type: 'EMIT_AUTHENTICATED',
      accessToken: e.output.accessToken,
    };
  }

  return {
    type: 'EMIT_AUTHENTICATED',
    accessToken: e.output.accessToken,
    email: e.output.user?.email as string | undefined,
  };
}

export default notifyAuthenticated;
